import ActionsForm from '@/shared/mixins/actionsForm'
export default {
  props: {
    edit: {
      type: Object,
      default: []
    }
  },
  name: 'Abstractaccredited',
  mixins: [ActionsForm],
  title: 'Resumo',
  mounted () {
    this.statusColor.backgroundColor = ['#30a75f', '#db3939'][this.edit.situacao]
    this.statusText = ['Ativo', 'Inativo'][this.edit.situacao]
  },
  data () {
    return {
      statusText: 'Ativo',
      statusColor: {
        backgroundColor: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/abstractaccredited/abstractaccredited.js